/* eslint-disable */

import React from 'react';

export default (props) => {
    const className = ['uig-button', 'uig-primary-button'];
    if (props.className)
        className.push(props.className);

    props = Object.assign({}, props, {
        className: className.join(' '),
        role: 'button'
    });

    return <a {...props} />;
};
